import styled from "styled-components";

export const Played = styled.span`
  font-family: ${(props) => props.theme.fonts.aeonik};
  font-style: normal;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: ${(props) => props.theme.colors.neutrals.primary.white};
`;

export const Total = styled.span`
  ont-family: "Aeonik";
  font-style: normal;
  font-size: 0.875rem;
  line-height: 1.25rem;
  letter-spacing: -0.006em;
  color: ${(props) => props.theme.colors.neutrals.primary.graytext};

  &:before {
    margin: 0 0.25rem;
    display: inline-block;
    content: "/";
  }
`;

export const Wrapper = styled.div`
  display: flex;
`;
